import { IAnalogSetpoint } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import ValueInput from './ValueInput';
import { themedUseStyletron } from '../../../theme/customTheme';

export function OverviewPanel(props: IAnalogSetpoint) {
  const [css, theme] = themedUseStyletron();

  return (
    <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight}  {...props}>
        <ValueInput {...props} />
    </OverviewPanelWrapper>
  );
}